export default __webpack_public_path__ + "static/media/logo.9926b152.jpeg";